module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"WishListInfo":{"titleScreenReader":"Oblíbené položky"}},"de":{"WishListInfo":{"titleScreenReader":"Oblíbené položky"}},"sk":{"WishListInfo":{"titleScreenReader":"Obľúbené položky"}}}')
  delete Component.options._Ctor
}
